import Content from "./components/content";
import Navigation from "./components/navigation";

export default function App() {
    return (
        <div className="topgraphiql-container">
            <Navigation />
            <Content />
        </div>
    );
}
